import { copyrightYear } from '@packages/core-shared';
import styles from './Footer.module.css';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <span>©&nbsp;{copyrightYear()} Perci Health. All rights reserved.</span>
      <span>Perci Health – Confidential</span>
    </footer>
  );
}
